export default {
  name: 'DodaLogin',
  displayName: {
    en: 'doda Campus Login',
    ja: 'dodaキャンパスログイン',
  },
  defaultWidth: 160,
  defaultHeight: 36,
  resizeX: true,
  props: [
    {
      name: 'type',
      displayName: {
        en: 'Type',
        ja: 'タイプ',
      },
      type: 'text',
      default: 'contained',
      control: {
        type: 'menu',
        options: [
          {
            label: 'canvas.menuRight.elementTab.button.type.text',
            value: 'text',
          },
          {
            label: 'canvas.menuRight.elementTab.button.text.outline',
            value: 'outlined',
          },
          {
            label: 'canvas.menuRight.elementTab.button.text.button',
            value: 'contained',
          },
        ],
      },
    },
    {
      name: 'text',
      displayName: {
        en: 'Text',
        ja: 'テキスト',
      },
      type: 'text',
      default: 'Button',
      styles: {
        fontFamily: '@body',
        fontWeight: '600',
      },
    },
    {
      name: 'login_email',
      displayName: {
        en: 'Email (data binding)',
        ja: 'メールアドレス（データバインド）',
      },
      type: 'text',
    },
    {
      name: 'login_password',
      displayName: {
        en: 'Password (data binding)',
        ja: 'パスワード（データバインド）',
      },
      type: 'text',
    },
    {
      name: 'dc_user_id',
      displayName: {
        en: 'doda Campus user ID (required)',
        ja: 'dodaキャンパス側のユーザID（必須）',
      },
      type: 'userField',
    },
    {
      name: 'department_name',
      displayName: {
        en: 'Department name',
        ja: '学部名',
      },
      type: 'userField',
    },
    {
      name: 'sub_department_name',
      displayName: {
        en: 'Sub-department name',
        ja: '学科名',
      },
      type: 'userField',
    },
    {
      name: 'graduate_year',
      displayName: {
        en: 'Graduation year (e.g. 2027)',
        ja: '卒業年度（例：2027）',
      },
      type: 'userField',
      dataTypes: ['number'],
    },
    {
      name: 'student_id',
      displayName: {
        en: 'Student ID',
        ja: '学籍番号',
      },
      type: 'userField',
    },
    {
      name: 'last_name',
      displayName: {
        en: 'Last name',
        ja: '氏名・姓',
      },
      type: 'userField',
    },
    {
      name: 'first_name',
      displayName: {
        en: 'First name',
        ja: '氏名・名',
      },
      type: 'userField',
    },
    {
      name: 'email',
      displayName: {
        en: 'Email address (required)',
        ja: 'メールアドレス（必須）',
      },
      type: 'userField',
    },
    {
      name: 'action',
      type: 'action',
      displayName: {
        en: 'Button',
        ja: 'Button',
      },
    },
    {
      name: 'successActions',
      displayName: {
        en: 'Actions when doda Campus login succeeds',
        ja: 'ログイン成功時のアクション',
      },
      type: 'action',
    },
    {
      name: 'failedActions',
      displayName: {
        en: 'Actions when doda Campus login fails',
        ja: 'ログイン失敗時のアクション',
      },
      type: 'action',
    },
  ],
  style: {
    opacity: true,
    text: true,
    backgroundColor: true,
    borderRadius: true,
  },
};
